import { j as o } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as n } from "react";
const e = (t) => (
  // eslint-disable-next-line react/display-name
  n(
    ({ children: s, lookLike: a = t.lookLike, className: l = "", lightBackground: c = !1, ...i }, d) => {
      const p = i.as ?? t.semanticElement;
      return /* @__PURE__ */ o.jsx(
        p,
        {
          className: `rds-${a} ${c ? `rds-${a}--light` : ""} ${l}`,
          ...i,
          ref: d,
          children: s
        }
      );
    }
  )
), k = e({ semanticElement: "h1", lookLike: "display-title" });
k.displayName = "display-title";
const y = e({ semanticElement: "h1", lookLike: "title-1" });
y.displayName = "title-1";
const b = e({ semanticElement: "h2", lookLike: "title-2" });
b.displayName = "title-2";
const r = e({ semanticElement: "h2", lookLike: "sub-title-2" });
r.displayName = "sub-title-2";
const N = e({ semanticElement: "h3", lookLike: "title-3" });
N.displayName = "title-3";
const E = e({ semanticElement: "h3", lookLike: "sub-title-3" });
E.displayName = "sub-title-3";
const L = e({ semanticElement: "h4", lookLike: "title-4" });
L.displayName = "title-4";
const u = e({ semanticElement: "p", lookLike: "lead" });
u.displayName = "lead";
const g = e({ semanticElement: "p", lookLike: "body" });
g.displayName = "body";
const h = e({ semanticElement: "p", lookLike: "sub-body" });
h.displayName = "sub-body";
const m = e({ semanticElement: "span", lookLike: "tag" });
m.displayName = "base-tag";
const T = n(({ uppercase: t = !0, className: s = "", ...a }, l) => /* @__PURE__ */ o.jsx(m, { className: `${t ? "rds-tag-uppercase" : ""} ${s}`, ...a, ref: l }));
T.displayName = "tag";
const $ = e({ semanticElement: "strong", lookLike: "bold" });
$.displayName = "bold";
const f = e({ semanticElement: "span", lookLike: "meta" });
f.displayName = "meta";
const x = e({ semanticElement: "span", lookLike: "span" });
x.displayName = "span";
export {
  g as B,
  k as D,
  L as H,
  u as L,
  f as M,
  x as S,
  T,
  y as a,
  b,
  N as c,
  $ as d,
  h as e,
  r as f,
  E as g
};
